module.exports = __webpack_public_path__ + "img/icon-use-the-extension.15fdac6e.png";